import { type ReactElement, type ReactNode } from 'react';
import { Stack, type GapStep } from '@vello/web-theme';

const SPACE_TOKEN = /^var\(--space-(\d+)\)$/;

/**
 * The vertical rhythm of a record drawer's body (the clones drew `flex column + gap 16/18/20` inline in every drawer). `gap` is a
 * space step, or the `var(--space-N)` reference older call sites still pass.
 */
export function DrawerStack({ children, gap = 4 }: { children: ReactNode; gap?: GapStep | `var(--space-${number})` }): ReactElement {
  const step = typeof gap === 'number' ? gap : (Number(SPACE_TOKEN.exec(gap)?.[1] ?? 4) as GapStep);
  return <Stack gap={step}>{children}</Stack>;
}
